import loadable from "@loadable/component";

export const SecurityLocks = loadable(() => import("./SecurityLocks"), {
  resolveComponent: mod => mod.SecurityLocks,
});
